import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { AppUrls } from '../../app.urls';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  email: string;
  emailSent = false;
  errorCode: string;
  errorMessage: string;
  busy: boolean;

  constructor(private auth: AngularFireAuth,
              private router: Router) {
  }

  ngOnInit(): void {
    this.busy = false;
  }

  resetPassword(): void {
    this.emailSent = false;
    this.errorCode = undefined;
    this.busy = true;
    this.auth.sendPasswordResetEmail(this.email)
      .then(() => {
        this.emailSent = true;
      })
      .catch(error => {
        this.errorMessage = error.toLocaleString();
        this.errorCode = error.code;
      })
      .finally(() => {
        this.busy = false;
      });
  }

  goBackToLogin(): void {
    this.router.navigate([AppUrls.ROOT, AppUrls.Login], { replaceUrl: true });
  }
}
